var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"binds-drawer binds-right-previous",class:_vm.drawerClasses})
}
var staticRenderFns = []

export { render, staticRenderFns }